/* global axios */
import ApiClient from './ApiClient';

class KanbanStagesAPI extends ApiClient {
  constructor() {
    super('kanban_stages', { accountScoped: true });
  }

  reorder(ids) {
    return axios.post(`${this.url}/reorder`, { ids });
  }
}

export default new KanbanStagesAPI();
